export class PayType {
  static get Day () {
    return 1
  }
  static get Month () {
    return 2
  }
  static get Quantity () {
    return 3
  }

  static PayTypeName (PayType) {
    let tmpType = parseInt(PayType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '天數'
        break
      case 2:
        name = '月份'
        break
      case 3:
        name = '計量'
        break
    }
    return name
  }
}
